<template>
  <span v-if="activeSort" class="SortingOptions justify-content-center align-items-center ml-1">
    <svg :class="{reverse: activeSort === 'asc'}" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="currentColor">
      <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
    </svg>
  </span>
</template>

<script>

export default {
  props: {
    activeSort: {
      type: String,
      required: false,
    },
  },
}

</script>

<style scoped>

.SortingOptions {
  display: inline-flex;
  position: absolute;
  color: #565656;
  margin-bottom: 5px;
  width: 15px;
  height: 15px;
  border: 1px solid #D1D3D4;
  border-radius: 1px;
}

svg {
  transform: rotate(0);
  margin-top: -1px;
  margin-left: 1px;
}

.reverse {
  transform: rotate(180deg);
}

</style>
